module.exports = __webpack_public_path__ + "static/media/medal.8751ce3a.svg";